<p>add-invoice-items works!</p>
